import { type FailureReasons } from './failure-reasons';

type ReportToTestExecutor = (payload: {
  type: 'skip-test' | 'external-dependency-checkpoint';
  testName: string;
  source: keyof typeof FailureReasons;
}) => void;

export { FailureReasons } from './failure-reasons';

/**
 * The following APIs are exposed by our playwright script.
 * These are only available when the app is loaded via playwright.
 */
declare global {
  // eslint-disable-next-line no-var
  var reportToTestExecutor: ReportToTestExecutor | undefined;
  // eslint-disable-next-line no-var
  var getTestName: () => Promise<string>;
}

export class HostNotifier {
  public async reportExternalCheckpoint(potentialFailureReasons: FailureReasons) {
    if (!globalThis.reportToTestExecutor) {
      return;
    }

    const testName = (await globalThis.getTestName?.()) ?? 'default-test-name';
    globalThis.reportToTestExecutor({
      type: 'external-dependency-checkpoint',
      testName,
      source: potentialFailureReasons,
    });

    console.log(
      `Reporting external checkpoint to test executor. ${potentialFailureReasons}`
    );
  }

  public async reportExternalFailure(reason: FailureReasons) {
    if (!globalThis.reportToTestExecutor) {
      return;
    }

    const testName = (await globalThis.getTestName?.()) ?? 'default-test-name';
    globalThis.reportToTestExecutor({
      type: 'skip-test',
      testName,
      source: reason,
    });

    console.log(`Reporting to test executor. ${reason}`);
  }
}

export const hostNotifier = new HostNotifier();
